module.exports = __webpack_public_path__ + "assets/img/logo.82b9c7a5.png";